import {
  TeamMembersDTO,
  SetTeamDetailsResponseDTO,
  CurrentUserDTO,
  SendInvitesResponseDTO,
  InviteDTO,
  UsersMembersDTO,
} from './server-types';
import buildAccountServerApi from './account-server-api';
import buildSiteServerApi from './site-server-api';
export { INVITES_ENDPOINT } from './account-server-api';
import { PolicyDTO } from '../types/roles';

export interface ServerApi {
  fetchTeamMembers(usersLimit?: number | boolean): Promise<TeamMembersDTO>;

  fetchTeamMemberUsers(limit: number, pageNum: number): Promise<UsersMembersDTO>;

  removeContributor(userId: string): Promise<any>;

  revokeInvite(inviteId: string): Promise<any>;

  resendInvite(inviteId: string): Promise<InviteDTO>;

  inviteContributorsWithPolicyIds(
    emails: string[],
    policyIds: string[],
    accountId: string,
  ): Promise<SendInvitesResponseDTO>;

  setTeamDetails(
    accountId: string,
    accountName: string,
    accountImg: string
  ): Promise<SetTeamDetailsResponseDTO>;

  setInviteDetails(
    inviteId: string,
    policyIds: string[],
  ): Promise<any>;

  setContributorDetails(
    userId: string,
    policyIds: string[],
  ): Promise<any>;

  fetchCurrentUserDetails(): Promise<CurrentUserDTO>;

  createRole(policy: Partial<PolicyDTO>): Promise<{ policy: PolicyDTO }>;

  updateRoleStatements(policy: Pick<PolicyDTO, 'id' | 'statements'>): Promise<{ policy: PolicyDTO }>;

  updateRoleMeta(policy: Omit<PolicyDTO, 'statements'>): Promise<{ policy: PolicyDTO }>;

  removeRole(roleId: string): Promise<any>;

  isAppInstalled(AppDefId: string): boolean;

  resendTransferOwnershipEmail(): Promise<any>;

  cancelTransferOwnership(): Promise<any>;

  fetchContributorLimit(): Promise<any>;
}

export const buildServerApi = (msid?: string): ServerApi => {
  if (msid) {
    return buildSiteServerApi(msid);
  } else {
    return buildAccountServerApi();
  }
};
